const DEFAULT_IMAGE = 'White Melamine';
        const PERCENT = 100;
        const LETTER_FOR_PRICE = 'a';

        window.initColorPicker = function initColorPicker(id) {
            const currentColorSet = window.datasetIds[id];
          console.log(`currentColorSet: ${currentColorSet}`);
          
            const setPrice = () => {
              console.log('yesyes');
              var getPrice= document.querySelector("span#ProductPrice").innerHTML;
              getPrice = getPrice.replace('USD', '');
              document.querySelector("button.product-form__submit.button.button--full-width.button--primary.mw-apo-add-to-cart-cloned #ProductPrice").innerHTML = getPrice;
            };
          

            
            document.querySelectorAll('.mw-option__control.mw-option__control--type-select').forEach((item) => {
              console.log(item.length);
                item.addEventListener('change', (event) => {
                    setPrice();
                });
            });
          
            document.querySelectorAll('.mw-option.mw-option--type-button.size-button .mw-option__value').forEach((item) => {
                item.addEventListener('click', (event) => {
                    setPrice();
                });
            });
            document.querySelectorAll('.mw-option.mw-option--type-button.size-guide-btn .mw-option__value').forEach((item) => {
                item.addEventListener('click', (event) => {
                    setPrice();
                });
            });
            document.querySelectorAll('.mw-option.mw-option--type-button.size-guide-btn1 .mw-option__value').forEach((item) => {
                item.addEventListener('click', (event) => {
                    setPrice();
                });
            });
            document.querySelectorAll('.mw-option.sofachart.sofasizes .mw-option__value').forEach((item) => {
                item.addEventListener('click', (event) => {
                    setPrice();
                });
            });
          var allButtons = document.querySelectorAll('.quantity__button');
          
          for (var i = 0; i < allButtons.length; i++) {
            allButtons[i].addEventListener('click', function() {
                    setPrice();
            });
          }
          
            document.querySelectorAll('.mw-option.mw-option--type-radio').forEach((item) => {
              console.log(item.length);
                item.addEventListener('change', (event) => {
                    setPrice();
                });
            });

            var getPrice= document.querySelector("span#ProductPrice").innerHTML;
            getPrice = getPrice.replace('USD', '');
            if(document.querySelector("button.product-form__submit.button.button--full-width.button--primary.mw-apo-add-to-cart-cloned #ProductPrice")){
            document.querySelector("button.product-form__submit.button.button--full-width.button--primary.mw-apo-add-to-cart-cloned #ProductPrice").innerHTML = getPrice;
            }

            const undoPrice = (side) => {
                const selectWrapper = document.querySelector(`.extra-hidden__item_${side}`);
                if (selectWrapper) {
                    const selector = selectWrapper.querySelector('select');
                    selector.value = null;
                }
            console.log(selectWrapper);
            };

            const updatePrice = (percent, selectedPrice, side) => {
                const selectWrapper = document.querySelector(`.extra-hidden__item_${side}`);
                if (selectWrapper) {
                    if (percent) {
                      console.log('yesyes');
                        const selector = selectWrapper.querySelector('select');
                        const newPrice = (Number(percent) / 100) * Number(selectedPrice);
                        selector.value = `${newPrice}`;
                        //const price = document.querySelector("#mwAddToCart");
                      const price = document.querySelector("button.product-form__submit.button.button--full-width.button--primary.mw-apo-add-to-cart-cloned");
                        const spanCtrl = price.querySelector(".productValue");
                        const originPrice = spanCtrl.getAttribute("orig-price");
                        spanCtrl.innerHTML = `$${Number(newPrice) + Number(originPrice)}`;
                    }
                }
            };

            const getSelect = (side) => {
               // console.log(`side2: ${side}`)
                const el = document.getElementsByClassName(side)[0];
               // console.log(`el: ${el}`)
                return el.getElementsByTagName('select')[0];
            }

            const getId = (side) => {
               // console.log(`side: ${side}`)
                const select = document.querySelector(`.${side}`);
               // console.log(`select: ${select}`)
                if (select) {
                    const item = select.querySelector('select');
                    return item.getAttribute('id');
                }
            };

            const findImage = (query) => currentColorSet.find(({ colorName }) => colorName === query);
              //  console.log(`colorName: ${colorName}`);

            const leftSelectId = getId('left-cabinet');
            const rightSelectId = getId('right-cabinet');
                console.log(`leftSelectId: ${leftSelectId}`);
                console.log(`rightSelectId: ${rightSelectId}`);

              function removeHTML(htmlString) {
                const tempElement = document.createElement('div');
                tempElement.innerHTML = htmlString;
                let textContent = tempElement.textContent || tempElement.innerText || '';
                textContent = textContent.replace(/\(.*?\)/g, '').trim();
                return textContent;
              }
          
            const setPictureOnSelect = (target, side) => {
              setTimeout(function(){
                resetOpenViewState()
              console.log(`target: ${target}`);
                let selectedOption = target.selectedOptions[0];
                let targetHTML = selectedOption.innerHTML || null;
                let currentValue = removeHTML(targetHTML);
              
                const currentDataSet = target.options[target.selectedIndex].dataset;
              
                const key = currentValue.split(' ')[0];
              
                const selectedSwatch1 = document.querySelector('span.mw-text.mw-accumulated-title').innerHTML;
                const selectedSwatch = removeHTML(selectedSwatch1);
              
                /*const image = document.querySelector(
                    `img[data-value-id="${currentDataSet.valueId}"]`,
                );*/
         
              let selector= target.id;
              console.log(`selector: ${selector}`);
              let selector1 = selector.replace("select_","");
              console.log(`selector1: ${selector1}`);
             // console.log(`selector1: ${selector1}`);
              let get_class = document.querySelector(`#${selector1}`).className;
              console.log(`get_class: ${get_class}`);
              var finalclass="";
              if (get_class.includes("left-cabinet")) {
               //  var finalclass="left";
                var finalclass="left-cabinet-imgc";
              }
              if (get_class.includes("right-cabinet")) {
                // var finalclass="right";
                var finalclass="right-cabinet-imgc";
              }
              console.log(`finalclass: ${finalclass}`);
              
              /*const image = document.querySelector(
                    `img.mws-img.${finalclass}`
                );*/
                const image = document.querySelector(
                    `img.${finalclass}`
                );
              console.log(`image: ${image}`);
              
                /*const image = document.querySelector(
                    `img[data-value-id="${currentDataSet.valueId}"]`,
                );*/
                if (selectedSwatch) {
                    //const currentImage = findImage(selectedSwatch.dataset.valueText);
                    const currentImage = findImage(selectedSwatch);
                  //console.log(`currentImage: ${currentImage.openView}`);
                    initOpenView(currentImage.openView);
                    if (currentValue === 'None' || currentValue === null) {
                        undoPrice(side);
                    } else {
                        updatePrice(currentImage.price, currentDataSet.valuePrice, side);
                    }
                    if (image) {
                        image.setAttribute('src', currentImage[key]);
                    }
                } else {
                    const currentImage = findImage(DEFAULT_IMAGE);
                    if (currentValue === 'None' || currentValue === null) {
                        undoPrice(side);
                    } else {
                        updatePrice(currentImage.price, currentDataSet.valuePrice, side);
                    }
                    image.setAttribute('src', currentImage[key]);
                }
                setPrice();
                },600);
            };

            const updatePriceOnSwatchChange = (currentImage, side) => {
             // console.log(`side1: ${side}`);
            //  console.log(`currentImage: ${currentImage}`);
                const cabinet = getSelect(`${side}-cabinet`)
              console.log(`cabinet: ${cabinet}`);
             // console.log(`cabinet.selectedIndex: ${cabinet.selectedIndex}`);
              //console.log(`options: ${cabinet.options[cabinet.selectedIndex]}`);
                const dataset = cabinet.options[cabinet.selectedIndex].dataset
              //console.log(`dataset: ${dataset.valuePrice}`);
                if (dataset.valuePrice != 0) {
                    updatePrice(currentImage.price, dataset.valuePrice, side);
                }
            }

            const leftSelect = document.getElementById(leftSelectId);
            if (leftSelect) {
                leftSelect.addEventListener('change', (event) => {
                    setPictureOnSelect(event.target, 'left');
                });
            }

            const rightSelect = document.getElementById(rightSelectId);
            if (rightSelect) {
                rightSelect.addEventListener('change', (event) => {
                    setPictureOnSelect(event.target, 'right');
                });
            }

            const setImageOnSwatch = (selector, currentImage) => {
             // console.log(`selector: ${selector}`);
             // console.log(`currentImage: ${currentImage}`);
                let element = document.getElementById(selector);
             // console.log(`element: ${element}`);
                let selectedOption = element.selectedOptions[0];
                let targetHTML = selectedOption.innerHTML || null;
                let currentValue = removeHTML(targetHTML);
             // console.log(`currentValue: ${currentValue}`);
                //let key = element ? element.value.split(' ')[0] : 'A';
               let key = currentValue.split(' ')[0];
            //  console.log(`key: ${key}`);
             // console.log(`selectedIndex: ${element.selectedIndex}`);
              
                let dataset = element.options[element.selectedIndex].dataset;
             // console.log(`dataset: ${dataset}`);
                /*let imageElement = document.querySelector(
                    `img[data-value-id="${dataset.valueId}"]`,
                );*/
              let selector1 = selector.replace("select_","");
             // console.log(`selector1: ${selector1}`);
              let get_class = document.querySelector(`#${selector1}`).className;
            //  console.log(`get_class: ${get_class}`);
              var finalclass="";
              if (get_class.includes("left-cabinet")) {
                // var finalclass="left";
                var finalclass="left-cabinet-imgc";
              }
              if (get_class.includes("right-cabinet")) {
                // var finalclass="right";
                var finalclass="right-cabinet-imgc";
              }
              
              /*let imageElement = document.querySelector(
                    `img.mws-img.${finalclass}`
                );*/
              let imageElement = document.querySelector(
                    `img.${finalclass}`
                );
            //  console.log(`currentImage: ${currentImage[key]}`);
                if (imageElement) {
                    imageElement.setAttribute('src', currentImage[key]);
                }
            };
          
            const itemSelected = () =>
                document.querySelectorAll('.mw-option__value--selected').length;

            document.querySelectorAll('.mw-option__swatch-media').forEach((item) => {
                item.addEventListener('click', (event) => {
                  setTimeout(function(){
                    resetOpenViewState()
                    if (itemSelected()) {
                        setPrice();
                        const currentTarget = event.target;
             console.log(`currentTarget: ${currentTarget}`);
                        const clickedElement = currentTarget.parentNode.dataset;
            //  console.log(`clickedElement: ${clickedElement}`);
                      
                const selectedSwatch1 = document.querySelector('span.mw-text.mw-accumulated-title').innerHTML;
                const colorValue = removeHTML(selectedSwatch1);
                        /*const colorValue = currentTarget.dataset.valueText
                            ? currentTarget.dataset.valueText
                            : clickedElement.valueText;*/
    /*const childElement = event.currentTarget.querySelector('img');
    console.log(`childElement: ${childElement}`);
                      
     const colorValue = childElement.getAttribute('title');*/
   // console.log(colorValue);

                      
             console.log(`colorValue: ${colorValue}`);
                        const currentImage = findImage(colorValue);
             // console.log(`currentImage: ${currentImage.openView}`);
                        initOpenView(currentImage.openView);
                        setImageOnSwatch(leftSelectId, currentImage);
                        setImageOnSwatch(rightSelectId, currentImage);
                        updatePriceOnSwatchChange(currentImage, 'left');
                        updatePriceOnSwatchChange(currentImage, 'right')
                    } else {
                        const currentImage = findImage(DEFAULT_IMAGE);
                        initOpenView(currentImage.openView);
                        setImageOnSwatch(leftSelectId, currentImage);
                        setImageOnSwatch(rightSelectId, currentImage);
                        undoPrice('left');
                        undoPrice('right');
                    }
                  },800);
                });
            });
            const currentImage = findImage(DEFAULT_IMAGE);
            console.log(currentImage.openView)
            console.log('yes')
            initOpenView(currentImage.openView);
            //const heading = document.querySelector('.mw_product_option_label');
           // heading.style.height = '500';
        };
